import React from 'react'
import PropTypes from 'prop-types'
import Path from '@leverege/path'
import ObjectUtil from '@leverege/object-util'

import { Button } from 'react-bootstrap'
import { InterpolatorSelector, InterpolatorFactory } from '~/editors/interpolators'

import style from './style.css'

export default class InterpolatorEditor extends React.Component {
  
  static propTypes = {
    attribute : PropTypes.object,
    timeline : PropTypes.object,
    keyframe : PropTypes.object,
    onChange : PropTypes.func.isRequired,
    onSwitchToKeyframe : PropTypes.func.isRequired,
    onCancel : PropTypes.func.isRequired,
  }

  onInterpolatorChange = ( evt ) => {

    const { timeline, keyframe, onChange } = this.props
    const mdl = ObjectUtil.copy( evt.target )
    Path( evt.path ).set( mdl, evt.value )
    onChange( { interpolator : mdl, keyframe, timeline } )
  }

  onSelect = ( item ) => {
    const { timeline, keyframe } = this.props
    this.props.onChange( { interpolator : ObjectUtil.copy( item ), keyframe, timeline } )
  }

  render() {
    const { attribute, keyframe, onSwitchToKeyframe, onCancel } = this.props
    const prps = { interpolator : keyframe.interpolator, focus : true, onChange : this.onInterpolatorChange }
    const editor = InterpolatorFactory.createEditor( keyframe.interpolator, prps );
    return ( 
      <div>
        <div className={style.interpolatorEditor}>
          <InterpolatorSelector className={style.interpolatorSelector} attribute={attribute} interpolator={keyframe.interpolator} hint="" fontIcon="" onSelect={this.onSelect} />
          {editor}
          <div className={style.interpolatorEditorButtons}>
            <Button bsStyle="link" onClick={onCancel}>Close</Button>
            <Button bsStyle="link" onClick={onSwitchToKeyframe}>Add Keyframe</Button>
          </div>
        </div>
      </div>
    )
  }
}
